import ShopifyLiveSale from "components/Reports/DashboardComponents/ShopifyLiveSale/ShopifyLiveSale";
import * as React from "react";

const ExtShopifyLiveSale = () => {
	return <ShopifyLiveSale />;
};

export default ExtShopifyLiveSale;
